<template>
  <div class="auth">
    <div class="container">
      <div class="auth__wrapper">
        <new-password-form />
      </div>
    </div>
  </div>
</template>

<script setup>
import NewPasswordForm from "@/components/forms/new-password-form.vue";
</script>

<style lang="scss" scoped>
.auth {
  padding-block: 75px;

  &__wrapper {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }
}
</style>